module.exports = __webpack_public_path__ + "static/media/NIMCLogo.31921d33.svg";